<template>
  <div class="container-fluid cardCustom">
    <div class="card cardCustom__side">
      <div class="cardCustom__header">
        <h5>Proposed Action Items From Consumption Analysis</h5>
      </div>
      <div class="content pt-12">
        <div v-if="total === 0">There are no proposed action items for review.</div>
        <div v-else class="relative">
          <div class="space-y-3 overflow-auto" id="infinite-list">
            <ConsumptionNotificationRow
              v-for="notification in notifications"
              v-if="!notification.read"
              :key="notification.id"
              :notification="notification"
              @dismiss="markNotificationAsRead"
              @selected="consumptionMeterSelected"
            />
          </div>
          <transition name="fade">
            <div
              v-if="loadingNotifications"
              class="absolute top-0 left-0 w-full h-full flex items-center justify-center"
            >
              <div class="absolute top-0 left-0 w-full h-full bg-white opacity-80"></div>
              <div class="text-black relative flex justify-center">
                <span class="mr-4 text-3xl">Loading</span>
                <span class="inline-block">
                  <MoonLoader color="#000" size="40px"></MoonLoader>
                </span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsumptionNotificationsController from '@/controllers/Consumption/ConsumptionNotificationsController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import ConsumptionNotificationRow from './ConsumptionNotificationRow';

export default {
  name: 'ConsumptionNotifications',
  components: {
    ConsumptionNotificationRow,
    MoonLoader,
  },
  props: {
    consumption_category_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      total: null,
      lastPage: null,
      loadingNotifications: false,
      notifications: [],
      page: 1,
    };
  },
  computed: {
    hasActionItems() {
      return this.all_notifications.length > 0;
    },
  },
  mounted() {
    // Detect when scrolled to bottom.
    const listElm = document.querySelector('#infinite-list');
    if (listElm.scrollTop + listElm.clientHeight > listElm.scrollHeight) {
      this.page++;
      this.loadNotifications();
    }

    listElm.addEventListener('scroll', (e) => {
      if (listElm.scrollTop + listElm.clientHeight > listElm.scrollHeight - 1) {
        this.page++;
        this.loadNotifications();
      }
    });

    // Initially load some items.
    this.loadNotifications();
  },
  methods: {
    async markNotificationAsRead(notification) {
      await ConsumptionNotificationsController.markAsRead(notification.id);

      this.notifications = this.notifications.map((readNotification) => {
        if (readNotification.id === notification.id) {
          readNotification.read = true;
        }
        return readNotification;
      });

      this.page++;
      this.loadNotifications();
    },
    async loadNotifications() {
      const listElm = document.querySelector('#infinite-list');
      listElm.removeEventListener('scroll', (e) => {});
      if (this.page >= this.lastPage && this.lastPage !== null) return;

      this.loadingNotifications = true;
      const {
        data: notifications,
        meta: { total, last_page },
      } = await ConsumptionNotificationsController.index({
        consumption_category_id: this.consumption_category_id,
        per_page: 20,
        page: this.page,
      });

      this.total = total;
      this.lastPage = last_page;
      this.notifications = this.notifications.concat(notifications);
      this.loadingNotifications = false;
    },
    consumptionMeterSelected(meter) {
      this.$emit('meter_selected', meter);
    },
  },
};
</script>

<style scoped>
#infinite-list {
  min-height: 75px;
  max-height: 400px;
}
</style>
